module.exports = __webpack_public_path__ + "static/media/ic-video-soundon.8079510a.svg";